import ReactPixel from 'react-facebook-pixel';
export const startTrackingPixel = () => {} 

try { ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL) } catch (e) { console.log(e) };
export default ReactPixel;